import GridcoLogo from "../../icons/gridco-logo.png";
export default function GridcoHeading({ title }: { title: string }) {
  return (
    <div className="header flex items-center justify-between">
      <h1>{title}</h1>
      <div className="flex flex-row justify-center items-center space-x-2 ">
        {/* <RuvitlLogo width={"40px"} height={"60px"} /> */}
        <img
          src={GridcoLogo}
          alt="Gridco Logo"
          style={{ width: "40px", height: "60px" }}
        />
        <h1>GRIDCO Power Analytics Center</h1>
      </div>
    </div>
  );
}
export function GridcoTitle() {
  return (
    <div className="flex flex-row justify-center items-center space-x-4 py-2  text-nowrap">
      {/* <RuvitlLogo width={"40px"} height={"60px"} /> */}
      <img src={GridcoLogo} alt="Gridco Logo" style={{ height: "45px" }} />
      <h1>GRIDCO Power Analytics Center</h1>
    </div>
  );
}

interface FooterProps {
  source: string;
  note?: string;
}

export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
  return (
    <div className="gna-footer-container">
      <div className="flex justify-between">
        <p className="gna-footer-text">{source}</p>
        <p className="gna-footer-text">Powered by GNA Energy</p>
        {/* <p className="gna-footer-text">Beta Version</p> */}
      </div>
      {note && <p className="gna-footer-note">{note}</p>}
    </div>
  );
};
